<template>
  <div class="app">
    <download-pamphlet-modal
      v-show="isPamphletModalVisible"
      @hideModal="hideDownloadPamphletModal"/>
    <call-modal
      v-show="isCallModalVisible"
      @hideModal="hideCallModal"/>
    <div class="app__searchbox">
      <!-- 元々ここにタイトル  -->
      <div class="app__searchboxConditions">
        <div class="searchTitle">
          <p class="searchBoxDiscriptionTitle">
            <i class="fa-solid fa-magnifying-glass-location"></i>
            介護施設を探す
          </p>
        </div>
        <div class="searchCondition">
          <label for="mapCenter">住所で検索</label>
          <div class="input-group">
            <GmapAutocomplete
              @place_changed="onPlaceChanged"
              @center_changed=""
              :select-first-on-enter="true"
              placeholder="地名、駅名などを入力後、リストから1つを選択"
              class="autoComplete form-control"
            />
          </div>
        </div>
      </div>
    </div>
    <div class='alert alert-danger' style='margin-bottom: 0px; font-size: 1rem;' v-if="mapZoom < 12">
      表示範囲が広すぎます。地図をズームし、施設を表示してください
    </div>
    <div class="app__result">
      <result-list @onCardSelected="onCardSelected"/>
      <div class="app__resultMap" style='position: relative;'>
          <vue-loading
            type="spin"
            color="#008B54"
            v-show="mapOnLoading"
            :size="{ width: '50px', height: '50px' }"
            >
          </vue-loading>
        <GmapMap
          :center = "{lat: mapLat, lng: mapLon}"
          :zoom = "mapZoom"
          :options = mapOptions
          ref = "map"
          @zoom_changed = 'onZoomChanged'
          @bounds_changed = 'onBoundsChanged'
          @dragend = 'onDrag'
          @idle = 'onIdle'
          :style="mapStyle">
          <GmapInfoWindow
            :options="infoWindowOptions"
            :position="infoWindowPosition"
            :opened="infoWindowOpened"
            @closeclick="onInfoWindowClosed">
          </GmapInfoWindow>
            <GmapMarker
              :key="centerPinId"
              :position="mapCenterPin"
              :clickabke="false"
              :icon="centerMarkerOptions"
              :draggable="false" v-if="!(mapCenterPin.lat == null || mapCenterPin.lng == null)" />
            <GmapMarker
              :key="m.id"
              v-for="m in mapMarkers"
              :position="m.position"
              :clickable="true"
              :icon="m.is_sonaeru_center ? sonaeruMarkerOptions : defaultMarkerOptions"
              :draggable="false"
              @click="toggleInfoWindow(m)"/>
        </GmapMap>
      </div>
    </div>
  </div>
</template>

<script>
// view 開発用
import axios from 'axios'
import { mapGetters } from 'vuex'
import { VueLoading } from 'vue-loading-template'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import DownloadPamphletModal from '@/pages/search/top/download_pamphlet_modal'
import CallModal from '@/pages/search/top/call_modal'
import ResultList from '../../components/result_list.vue'
export default {
  name: 'Top',
  components: {
    VueLoading,
    GmapCluster,
    DownloadPamphletModal,
    CallModal,
    ResultList,
  },
  data() {
    return {
      isPamphletModalVisible: false,
      isCallModalVisible: false,
      clusterStyles: [
        {
          url: 'https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m1.png',
          height: 53,
          width: 53,
          textColor: '#fff',
          textSize: 16
        },
      ],
      mapOptions: {
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        gestureHandling: "greedy",
        v: "3",
        region: 'JP',
        language: 'ja',
        styles: [
          { featureType: 'administrative', stylers: [{ visibility: 'on' }] },
          { featureType: 'poi.attraction', stylers: [{ visibility: 'off' }] },
          { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
          { featureType: 'poi.government', stylers: [{ visibility: 'off' }] },
          { featureType: 'poi.medical', stylers: [{ visibility: 'off' }] },
          { featureType: 'poi.park', stylers: [{ visibility: 'off' }] },
          { featureType: 'poi.place_of_worship', stylers: [{ visibility: 'on' }] },
          { featureType: 'poi.school', stylers: [{ visibility: 'off' }] },
          { featureType: 'poi.sports_complex', stylers: [{ visibility: 'off' }] },
          { featureType: 'road', stylers: [{ visibility: 'on' }] },
          { featureType: 'transit', stylers: [{ visibility: 'on' }] },
          { featureType: 'water', stylers: [{ visibility: 'on' }] },
        ]
      },
      isDefaultIconVisible: false,
      mapStyle: "width: 100%; height:100%",
      infoWindowOpened: false,
      infoWindowPosition: null,
      infoWindowOptions: {
        content: null,
        pixelOffset: { widtn: 0, height: -35 }
      },
      keyword: null,
      centerPinId: 1,
      centerMarkerOptions: {
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Latin_Cross_with_Equal_Arms.svg/240px-Latin_Cross_with_Equal_Arms.svg.png',
        scaledSize: { width: 30, height: 30, f: 'px', b: 'px' },
        anchor: { x: 15,  y: 35 }
      },
      defaultMarkerOptions: {
        url: 'https://fuluna.s3.ap-northeast-1.amazonaws.com/orange_map_pin.png',
        scaledSize: { width: 22, height: 35, f: 'px', b: 'px' },
      },
      sonaeruMarkerOptions: {
        url: 'https://fuluna.s3.ap-northeast-1.amazonaws.com/sonaeru_pin.png',
        scaledSize: { width: 22, height: 35, f: 'px', b: 'px' },
      }
    }
  },
  async mounted() {
    // 緯度経度の指定なしで遷移(日本地図を全体的に表示)
    if(this.getParams('lat') == null || this.getParams('lon') == null){
      this.$store.commit('map/setLon', 137.5936)
      this.$store.commit('map/setLat', 38.0047)
      this.$store.commit('map/setZoom', 5)
      this.$store.commit('map/setCenterPin',
        { lat: 38.0047,
          lng: 137.5936 })
    // 緯度経度の指定ありで遷移(指定された点の周辺を表示)
    }else{
      this.$store.commit('map/setLon', Number(this.getParams('lon')))
      this.$store.commit('map/setLat', Number(this.getParams('lat')))
      this.$store.commit('map/setZoom', 14)
      this.$store.commit('map/setCenterPin',
        { lat: Number(this.getParams('lat')),
          lng: Number(this.getParams('lon')) })
    }
    this.$refs.map.$mapPromise.then((map) => {
      this.setMapSwitchingBtn()
    })
  },
  computed: {
    ...mapGetters('map', ['mapLat',
                          'mapLon',
                          'mapZoom',
                          'mapMarkers',
                          'mapBoundsRight',
                          'mapBoundsLeft',
                          'mapBoundsTop',
                          'mapBoundsBottom',
                          'mapSelectedMarkerId',
                          'mapOnLoading',
                          'mapCenterPin',
                          'mapResultListOpen']),
  },
  methods: {
    getParams(name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[\[\]]/g, "\\$&")
      let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, " "))
    },
    detailPageLink(marker){
      return `/map/care_homes/${marker.id}`
    },
    setMapSwitchingBtn(){
      let switchingBtn = document.createElement('button')
      switchingBtn.style.cssText = 'margin-right: 10px; border: 0px; border-radius: 2px; background: #fcfafa;'
      let switchingImg = document.createElement('img')
      switchingImg.src = 'https://kotonohaworks.com/free-icons/wp-content/uploads/kkrn_icon_map_6.png'
      switchingImg.style.cssText = 'height: 28px; width: 28px;'
      switchingBtn.appendChild(switchingImg)
      switchingBtn.addEventListener('click', () => {
        this.switchDefaultIcon()
      })
      this.$refs.map.$mapObject.controls[9].push(switchingBtn)
      // Position一覧: https://lab.syncer.jp/Web/API/Google_Maps/JavaScript/ControlPosition/
    },
    switchDefaultIcon(){
      if(this.isDefaultIconVisible){
        this.hideDefaultIcon()
        this.isDefaultIconVisible = false
      }else{
        this.showDefaultIcon()
        this.isDefaultIconVisible = true
      }
    },
    showDefaultIcon(){
      this.mapOptions.styles.filter(s => s.featureType == 'poi.attraction')[0].stylers[0].visibility = 'on'
      this.mapOptions.styles.filter(s => s.featureType == 'poi.business')[0].stylers[0].visibility = 'on'
      this.mapOptions.styles.filter(s => s.featureType == 'poi.sports_complex')[0].stylers[0].visibility = 'on'
    },
    hideDefaultIcon(){
      this.mapOptions.styles.filter(s => s.featureType == 'poi.attraction')[0].stylers[0].visibility = 'off'
      this.mapOptions.styles.filter(s => s.featureType == 'poi.business')[0].stylers[0].visibility = 'off'
      this.mapOptions.styles.filter(s => s.featureType == 'poi.sports_complex')[0].stylers[0].visibility = 'off'
    },

    onPlaceChanged(input) {
      if(input.formatted_address != undefined){
        this.$store.commit('map/setLat', input.geometry.location.lat())
        this.$store.commit('map/setLon', input.geometry.location.lng())
        this.$store.commit('map/setZoom', 14)
      }
    },
    onZoomChanged(input){
      this.$store.commit('map/setZoom', input)
    },
    onIdle() {
      // 地図がIdle状態になったらマーカー更新処理走らせる
      this.fetchMarkers()
    },
    onBoundsChanged(){
      let mapBounds = this.$refs.map.$mapObject.getBounds()
      this.$store.commit('map/setCenterPin',
        { lat: this.$refs.map.$mapObject.getCenter().lat(),
          lng: this.$refs.map.$mapObject.getCenter().lng() }
      )
      mapBounds = Object.entries(mapBounds)
      let latBounds = mapBounds[0][1]
      let lonBounds = mapBounds[1][1]
      this.$store.commit('map/setBoundsLeft', lonBounds['lo'])
      this.$store.commit('map/setBoundsRight', lonBounds['hi'])
      this.$store.commit('map/setBoundsTop', latBounds['hi'])
      this.$store.commit('map/setBoundsBottom', latBounds['lo'])
    },
    onClusterTapped(cluster){
      this.$store.commit('map/setLat', cluster['center_'].lat())
      this.$store.commit('map/setLon', cluster['center_'].lng())
      this.$store.commit('map/setZoom', this.mapZoom + 1)
    },
    onDrag(){
      this.$store.commit('map/setLat', null)
      this.$store.commit('map/setLon', null)
      $('.pac-target-input').val('')
    },
    onInfoWindowClosed(){
      this.infoWindowOpened = false
      this.$store.commit('map/setSelectedMarkerId', null)
    },
    onSearch() {
      this.fetchMarkers()
    },
    onCardSelected(marker){
      this.toggleInfoWindow(marker)
    },
    toggleInfoWindow(marker){
      this.infoWindowPosition = marker.position
      this.infoWindowOpened = true
      this.infoWindowOptions.content = marker.infoText
      this.$refs.map.panTo({lat: marker.position.lat, lng: marker.position.lng})
      this.$store.commit('map/setSelectedMarkerId', marker.id)
    },
    async fetchMarkers(){
      this.$store.commit('map/setOnLoading', true)
      // Zoom 12以上で施設データの取得
      if(this.mapZoom >= 12){
        try {
          const res = await axios.get(`/map/api/care_homes`, { params: {
            left: this.mapBoundsLeft,
            right: this.mapBoundsRight,
            top: this.mapBoundsTop,
            bottom: this.mapBoundsBottom,
            keyword: this.keyword,
            selected_id: this.mapSelectedMarkerId,
          }})
          this.$store.commit('map/setMarkers', res.data)
        } catch(e) {
          alert('error')
        }
      //Zoom9以下は検索結果のクリア
      }else{
        this.$store.commit('map/setMarkers', [])
        this.infoWindowPosition = null
        this.infoWindowOpened = false
        this.$store.commit('map/setSelectedMarkerId', null)
      }
      this.$store.commit('map/setOnLoading', false)
    },
    showDownloadPamphletModal() {
      this.isPamphletModalVisible = true
    },
    hideDownloadPamphletModal(){
      this.isPamphletModalVisible = false
    },
    showCallModal() {
      this.isCallModalVisible = true
    },
    hideCallModal(){
      this.isCallModalVisible = false
    }
  },
  watch: {
    mapResultListOpen: function(isOpen){
      if(isOpen){
        //中心をサイドバーの分だけ右にずらす処理
      }else{
        //中心を元に戻す処理
      }
    },
  }

}
</script>

<style scoped>
  .vue-loading{
    position:absolute;
    left:55%;
    top: 100px;
    z-index: 9999;
  }
</style>

